var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backbtn",on:{"click":function($event){return _vm.fanhui()}}},[_c('img',{attrs:{"src":require("../../assets/images/backicon.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }